import {FormGroup} from "@angular/forms";
import {
    AbstractFieldInputTypeHandlerComponent
} from "../../../type-handler/abstract-field-input-type-handler.component";
import {
    DrawingData
} from "../../../../../../../modules/common/drawing/drawing-on-image/drawingOnImageDrawingElement.model";
import {
    DrawingOnImageChangedEvent
} from "../../../../../../../modules/common/drawing/drawing-on-image/drawing-on-image.component";

export abstract class AbstractDrawableImageV2InputTypeHandler extends AbstractFieldInputTypeHandlerComponent<FormGroup>  {

    data: DrawingData;

    synchronizeRuleValue(): string {
        return this.data ? JSON.stringify({
            data: {
                items: this.data.items.map(value => {
                    return {
                        typeValue: value.typeValue,
                        subTypeValue: value.subTypeValue,
                        common: {
                            thickness: value.common.thickness,
                            color: value.common.color,
                            size: value.common.size,
                            label: value.common.label,
                            name: value.common.name
                        },
                        properties: value.properties
                    }
                })
            }
        }) : "";
    }

    changed(event: DrawingOnImageChangedEvent) {
        if (event) {
            this.data = event.data;
            this.jsonControl.patchValue(AbstractDrawableImageV2InputTypeHandler.buildPayload(event));
        }
    }

    public static buildPayload(event: DrawingOnImageChangedEvent): DrawablePayload {
        if (!event) {
            return undefined;
        }
        const items: DrawableDataItemPayload[] = event.data.items.map(value => {
            const common: DrawableDataItemCommonPayload = {
                thickness: value.common.thickness,
                color: value.common.color,
                size: value.common.size,
                label: value.common.label,
                name: value.common.name
            };

            const item: DrawableDataItemPayload = {
                typeValue: value.typeValue,
                subTypeValue: value.subTypeValue,
                common,
                properties: value.properties
            };

            return item;
        });

        return {
            image: event.image,
            data: {
                items
            }
        };
    }
}

export class DrawableDataItemCommonPayload {
    thickness!: number;
    color!: string;
    size!: number;
    label!: string;
    name!: string;
}

export class DrawableDataItemPayload {
    typeValue!: string;
    subTypeValue!: string;
    common!: DrawableDataItemCommonPayload;
    properties!: any; // Vous pouvez remplacer "any" par une classe ou une interface plus précise si vous connaissez la structure exacte
}

export class DrawableDataPayload {
    items!: DrawableDataItemPayload[];
}

export class DrawablePayload {
    image!: string;
    data!: DrawableDataPayload;
}